import {
  getObject,
  getInt32,
} from "@surya-digital/leo-ts-types";
import { Answer, AnswerDTO } from "./answer";

export interface RankingAnswerElementV1DTO {
  answer: AnswerDTO;
  rank: number;
}

export class RankingAnswerElementV1 {
  readonly isRankingAnswerElementV1RankingAnswerElementV1: boolean = true;

  readonly answer: Answer;
  readonly rank: number;


  constructor(
  answer: Answer, 
  rank: number
  ) {
    this.answer = answer;
    this.rank = rank;
  }

  static fromDTO(dto: RankingAnswerElementV1DTO): RankingAnswerElementV1 {
    const answer = Answer.fromDTO(getObject(dto, "answer", InvalidRankingAnswerElementV1AnswerError));
    const rank = getInt32(dto, "rank", InvalidRankingAnswerElementV1RankError);
    return new RankingAnswerElementV1(
      answer,
      rank
    );
  }

  toDTO(): RankingAnswerElementV1DTO {
    const dto: RankingAnswerElementV1DTO = {
        answer: this.answer.toDTO(),
        rank: this.rank
    };
    return dto;
  }
  }

RankingAnswerElementV1.prototype.toString = function toString(): string {
  return `RankingAnswerElementV1(answer='${this.answer}',rank='${this.rank}')`;
};

export class InvalidRankingAnswerElementV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingAnswerElementV1Error";
  }
}
export class InvalidRankingAnswerElementV1AnswerError extends InvalidRankingAnswerElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingAnswerElementV1AnswerError";
  }
}

export class InvalidRankingAnswerElementV1RankError extends InvalidRankingAnswerElementV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingAnswerElementV1RankError";
  }
}
